/**
 * cachedApi — sessionStorage cache + module-level in-flight dedup for api calls.
 *
 * Calling cachedApi("key", fn, ttl) twice simultaneously fires only one HTTP
 * request; both callers receive the same promise. Subsequent calls within TTL
 * are served from sessionStorage without hitting the network.
 *
 * Usage:
 *   import { cachedApi } from "@/lib/cachedApi";
 *   const data = await cachedApi("my_key_v1", () => api.get("/some/endpoint"), 5 * 60 * 1000);
 *
 * To force a fresh fetch (e.g. after a mutation), call invalidateCache("my_key_v1").
 */

const _inflight = {};

export function cachedApi(key, apiFn, ttlMs) {
  try {
    const c = JSON.parse(sessionStorage.getItem(key) || "null");
    if (c && Date.now() - c.ts < ttlMs) return Promise.resolve(c.data);
  } catch (_) {}

  if (!_inflight[key]) {
    _inflight[key] = apiFn()
      .then(r => {
        try { sessionStorage.setItem(key, JSON.stringify({ data: r.data, ts: Date.now() })); } catch (_) {}
        delete _inflight[key];
        return r.data;
      })
      .catch(e => { delete _inflight[key]; throw e; });
  }
  return _inflight[key];
}

export function invalidateCache(key) {
  try { sessionStorage.removeItem(key); } catch (_) {}
}

/** Remove todas as chaves que começam com `prefix` (ex.: uma por filial). */
export function invalidateCachePrefix(prefix) {
  try {
    Object.keys(sessionStorage)
      .filter(k => k.startsWith(prefix))
      .forEach(k => sessionStorage.removeItem(k));
  } catch (_) {}
}

/**
 * Conta a pagar e meta mexem no lucro e na meta do mês: o painel e o widget
 * da meta precisam buscar de novo, senão mostram o número velho por até 10 min.
 */
export function invalidateFinanceCaches() {
  invalidateCache("oplyx_dash_v1");
  invalidateCachePrefix("oplyx_mforecast_v1");
}
